export const ADMIN = ['admin', 'owner', 'root'];
export const OWNER = ['owner', 'root'];
export const ROOT = ['root'];
